<template>

    <div class="match-header">

        <div class="team-bg">
            <div class="team-background top-bg">
              <img :src="$urlOrDefault(match.teams_formatted.home.team.logo_picture,'logo')">
            </div>
            <div class="team-background bottom-bg">
              <img :src="$urlOrDefault(match.teams_formatted.away.team.logo_picture,'logo')">
            </div>
        </div>

        <div class="team-bg" style="background-color: rgba(10, 21, 28, 0.76);">
            <img :src="getImageUrl('assets/img/dot-img.png')">
        </div>

        <div class="team-inform">
            <div class="row tournament-info">
                <div class="col-sm-4 text-center team-details">
                    <img :src="$urlOrDefault(match.teams_formatted.home.team.logo_picture,'logo')" class="team-logo">
                    <h4 class="team-name">{{ match.teams_formatted.home.data.name }}</h4>
                    <h4 class="team-score">{{ match.teams_formatted.home.data.score }}</h4>
                </div>
                <div class="col-sm-4 text-center game-details">

                    <div class="game-info">
                        <div class="game-round">
                            <span class="bg-color">Quartos de final</span>
                        </div>

                        <div class="game-state">
                            <p v-if="match.status==='live'" class="live-text">{{ states[match.status] }}</p>
                            <p v-if="match.status!=='live'" v-html="formatDate(match.date_time_jogo, true)"></p>
                            <div  v-if="match.status==='live'" class="live-button">LIVE</div>
                        </div>
                    </div>

                    <div class="vs-button text-color border-color">
                        vs
                    </div>

                </div>
                <div class="col-sm-4 text-center team-details">
                    <img :src="$urlOrDefault(match.teams_formatted.away.team.logo_picture,'logo')" class="team-logo">
                    <h4 class="team-name">{{ match.teams_formatted.away.data.name }}</h4>
                    <h4 class="team-score">{{ match.teams_formatted.away.data.score }}</h4>
                </div>
            </div>
        </div>

        <div class="header-line border-color">
            <div class="stream-live bg-color" v-if="matchInfo.meta.hasOwnProperty('stream_embed_url') && matchInfo.status !== 'finished'">Transmissão RTP Arena</div>
        </div>


    </div>

</template>

<script>
    import Funcs from "../../functions";

    export default {
        name: "MatchHeader",
        props: {
            matchInfo: Object,
        },
        data: function(){
            return {
                match:this.matchInfo,
                states:{'comingup':'agendado','live':'a decorrer','finished':'finalizado'}
            }
        },
        methods: {
            formatDate(date,hours){
                return Funcs.formatDate(date,hours);
            },
            getImageUrl(url){
              return Funcs.getImageUrl(url);
            }
        }
    }
</script>

<style scoped>
    .text-center {
        text-align: center!important;
    }

    .match-header {
        height: 300px;
        width: 100%;
        background-color: #0A151C;
        position: relative;
    }

    .team-bg .team-background {
        height: 100%;
        width: 50%;
        position: relative;
        clip-path: polygon(0px 0px, 100% 0px, 100% 100%, 0px 100%);
    }

    .team-bg .team-background > img {
        width: 70%;
        height: auto;
        filter: blur(10px);
    }

    .team-bg .top-bg {
        float: left;
    }

    .team-bg .top-bg > img {
        margin-top: -100px;
        margin-left: -200px;
    }

    .team-bg .bottom-bg > img {
        margin-top: 50px;
        margin-left: 200px;
    }

    .team-bg .bottom-bg {
        float: right;
    }

    .team-bg {
        position: absolute;
        top:0;
        left:0;
        width:100%;
        height: 100%;
    }

    .team-inform {
        height: 100%;
        width: 100%;
        position: absolute;
        top:0;
        left:0;
    }

    .team-logo {
        width: 130px;
        height: 130px;
    }

    .tournament-info {
        height:100%;
    }

    h4 {
        font-family: Roboto;
        font-weight: bold;
        font-size: 24px;
        line-height: 32px;
        color: #FFF;
    }

    .tournament-info p, .game-state > p {
        font-family: Roboto;
        font-style: normal;
        font-weight: bold;
        font-size: 24px;
        line-height: 32px;
        color: #FFF;
    }

    .game-details {
        padding-top: 25px;
    }

    .game-info {
        height: 110px;
    }

    .game-details .game-state {
        margin-top: 15px;
    }

    .game-details .game-round {
        height: 27px;
    }

    .game-details .game-state > .live-text {
        font-size: 16px;
    }

    .game-details .game-state > .live-button {
        background-color: #EA5455;
        border-radius: 1px;
        font-family: Roboto;
        font-style: normal;
        font-weight: bold;
        font-size: 12px;
        color:#FFF;
        width: 20%;
        margin: 0 auto;
    }

    .game-details .game-round > span {
        font-family: Roboto;
        font-weight: 500;
        font-size: 13px;
        text-transform: uppercase;
        color:#000;
        padding: 5px 10px;
    }

    .team-details {
        padding-top: 35px;
    }

    .vs-button {
        font-family: Roboto;
        font-style: normal;
        font-weight: 500;
        font-size: 18px;
        text-transform: uppercase;
        border: 1px solid transparent;
        border-radius: 25px;
        padding: 10px;
        width: 45px;
        height: 45px;
        margin: 0 auto;
        margin-top: 20px;
    }

    .team-name {
        font-family: Roboto;
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        margin-top: 10px;
    }

    .team-score {
        font-family: Roboto;
        font-style: normal;
        font-weight: bold;
        font-size: 32px;
        line-height: 55px;
    }

    .header-line {
        width: 95%;
        height: 30px;
        position: absolute;
        bottom:0;
        left: 2.5%;
        border-bottom: 3px solid transparent;
    }

    .header-line > .stream-live {
        height: 100%;
        line-height: 30px;
        text-align: center;
        vertical-align: middle;
        color:#000;
        font-family: Roboto;
        font-style: normal;
        font-weight: bold;
        font-size: 14px;
        width:30%;
        margin: 0 auto;
        text-transform: uppercase;
        border-top-left-radius: 3px;
        border-top-right-radius: 3px;
    }
</style>
<style>
    .game-state > p > span {
        font-weight: normal;
    }
</style>